/* tslint:disable */

declare var Object: any;
export interface QualificationInterface {
  "sfdcId"?: string;
  "ts2__Job_Order__c"?: string;
  "CreatedById"?: string;
  "CurrencyIsoCode"?: string;
  "LastModifiedById"?: string;
  "Name"?: string;
  "ts2__MinimalScore__c"?: number;
  "ts2__Parsed__c"?: boolean;
  "ts2__Required__c"?: boolean;
  "ts2__Skill_Name__c"?: string;
  "ts2__Taxonomy__c"?: string;
  "ts2__TaxonomySkill__c"?: string;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
}

export class Qualification implements QualificationInterface {
  "sfdcId": string;
  "ts2__Job_Order__c": string;
  "CreatedById": string;
  "CurrencyIsoCode": string;
  "LastModifiedById": string;
  "Name": string;
  "ts2__MinimalScore__c": number;
  "ts2__Parsed__c": boolean;
  "ts2__Required__c": boolean;
  "ts2__Skill_Name__c": string;
  "ts2__Taxonomy__c": string;
  "ts2__TaxonomySkill__c": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  constructor(data?: QualificationInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Qualification`.
   */
  public static getModelName() {
    return "Qualification";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Qualification for dynamic purposes.
  **/
  public static factory(data: QualificationInterface): Qualification{
    return new Qualification(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Qualification',
      plural: 'Qualifications',
      path: 'Qualifications',
      idName: 'id',
      properties: {
        "sfdcId": {
          name: 'sfdcId',
          type: 'string'
        },
        "ts2__Job_Order__c": {
          name: 'ts2__Job_Order__c',
          type: 'string'
        },
        "CreatedById": {
          name: 'CreatedById',
          type: 'string'
        },
        "CurrencyIsoCode": {
          name: 'CurrencyIsoCode',
          type: 'string'
        },
        "LastModifiedById": {
          name: 'LastModifiedById',
          type: 'string'
        },
        "Name": {
          name: 'Name',
          type: 'string'
        },
        "ts2__MinimalScore__c": {
          name: 'ts2__MinimalScore__c',
          type: 'number'
        },
        "ts2__Parsed__c": {
          name: 'ts2__Parsed__c',
          type: 'boolean'
        },
        "ts2__Required__c": {
          name: 'ts2__Required__c',
          type: 'boolean'
        },
        "ts2__Skill_Name__c": {
          name: 'ts2__Skill_Name__c',
          type: 'string'
        },
        "ts2__Taxonomy__c": {
          name: 'ts2__Taxonomy__c',
          type: 'string'
        },
        "ts2__TaxonomySkill__c": {
          name: 'ts2__TaxonomySkill__c',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}
